import { Mock } from '@mock/model';

// Replaces mock.ts in every build configuration but local, so no fixture ships in a deployed bundle.
export const mock: Mock[] = [];
